import NotificationBellSVG from "assets/svg/notification-bell-svg";
import "./notification.css";

const AlertNotification = ({
  className,
  data,
  onClose = () => {},
  ...props
}) => {
  return (
    <div
      className={`alert-notification flex flex-row bg-white shadow-xl rounded px-5 py-3 ${className}`}
      {...props}
    >
      <div className="flex w-full flex-col">
        <div className="flex font-bold text-black text-opacity-50 uppercase text-xs items-center w-full relative">
          <div className="mr-5">
            <NotificationBellSVG />
          </div>
          <p>system notification</p>
          <span>&nbsp;&bull;&nbsp;</span>
          <p>{data.relativeTime || "Just Now"}</p>
          <p
            className="absolute right-0 text-2xl cursor-pointer"
            onClick={onClose}
          >
            &times;
          </p>
        </div>
        <div className="ml-9">
          <div>
            <p className="alert-notification-title font-bold text-base">
              {data.title || "Push Notification"}
            </p>
            <p className="text-black text-opacity-50 text-sm">
              {data.message ||
                "Lorem ipsum dolor sit amet consectetur adipisicing elit. Pariatur, repellendus."}{" "}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AlertNotification;
